import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  icon?: string;
  morePath?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  icon = "ri-fire-line",
  morePath,
  moreLabel = "更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-4 flex items-center justify-between border-b-2 border-background-200 pb-2.5">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-600 text-background-50">
          <i className={`${icon} text-sm`} />
        </span>
        {title}
      </h2>
      {morePath && (
        <Link
          to={morePath}
          className="flex items-center gap-1 text-sm text-foreground-500 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}